import { Dayjs } from 'dayjs';

export enum JobDashboardRange {
  TODAY = 'today',
  THIS_WEEK = 'this_week',
  THIS_MONTH = 'this_month',
  THIS_QUARTER = 'this_quarter',
  THIS_YEAR = 'this_year',
  LAST_24_HOURS = 'last_24_hours',
  LAST_7_DAYS = 'last_7_days',
  LAST_30_DAYS = 'last_30_days',
  LAST_90_DAYS = 'last_90_days',
  LAST_365_DAYS = 'last_365_days',
  ALL_TIME = 'all_time',
  CUSTOM = 'custom',
}

export interface JobDashboardConfiguration {
  dataConnectionIds?: string[];
  title?: string;
  description?: string;
  range: JobDashboardRange;
  from?: Dayjs;
  to?: Dayjs;
}
